@if (showBackButton) {
    <ng-container>
        <button type="button" (click)="goBack()" class="btn btn-secondary" style="position: absolute;z-index:800;">Back</button>
    </ng-container>
}
